import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AGGREGATE_NAMES, HTTP_STATUS, LOAN_REQUEST_COMMANDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { APICommunicator } from '~/api/APICommunicator';
import { invalidateAdvisorServiceQueries } from '~/features/leadDetails/utils/invalidateAdvisorServiceQueries';

export const useAddAssignedAdvisorMutation = (loanRequestId: string) => {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation({
        mutationFn: () =>
            APICommunicator.sendCommand({
                aggregateId: loanRequestId,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: LOAN_REQUEST_COMMANDS.addAssignedAdvisor,
                payload: {},
            }),
        onError: async (error: Error & { response?: string; status?: number }) => {
            if (error.status === HTTP_STATUS.FORBIDDEN) {
                toast.error(t('LEADS.ADVISOR_SERVICE.NOT_PERMITTED'));
                await invalidateAdvisorServiceQueries(queryClient, loanRequestId);
                return;
            }
            toast.error(t('LEADS.ADVISOR_SERVICE.ADD_ERROR'));
        },
        onSuccess: async ({ position }) => {
            await invalidateAdvisorServiceQueries(queryClient, loanRequestId, position);
            toast.success(t('LEADS.ADVISOR_SERVICE.ADD_SUCCESS'));
        },
    });
};
